<template>
  <div class="yeac_container" :style="{ backgroundImage: `url(${resourceBaseUrl}/background.jpg)` }">
    <!-- <div class="yeac_header" :style="{ backgroundImage: `url(${resourceBaseUrl}/header.png)` }"></div> -->
    <img class="yeac_header" :src="`${resourceBaseUrl}/header.png`" />
    <div class="yeac_nav">
      <div class="yeac_nav-back" v-for="(item, index) in brandList" :key="item" :class="index === currentBrandIndex
        ? 'yeac_nav-selected'
        : index == 0
          ? 'yeac_nav-top'
          : index == brandList.length - 1
            ? 'yeac_nav-bottom'
            : 'yeac_nav-unselected'
        " @click="handleBrandSelect(index)">
        <img :src="`${resourceBaseUrl}/${item.url}.png`" alt="" :style="{
          width: item.width / 100 + 'rem',
          transform: `scale(${index == currentBrandIndex ? 1.2 : 1})`,
        }" />
        <div class="yeac_nav-line" v-if="index != brandList.length - 1"></div>
      </div>
    </div>
    <div class="yeac_activity-area">
      <div class="yeac_brand-area" :style="{ backgroundImage: `url(${resourceBaseUrl}/${item.area}.png)` }"
        v-for="(item, index) in brandList" :id="item.url" :key="index">
        <img class="yeac_brand-activity" :class="{
          'yeac_brand-activity-line': idx != item.activityList.length - 1,
        }" v-for="(itm, idx) in item.activityList" @click="toActivityPage(itm.type, itm.id, itm.goodsSn, itm.goodsId)"
          :key="idx" :src="`${resourceBaseUrl}/${item.url}${itm.number < 1 ? idx + '-1' : idx}.png`" mode="widthFix"/>
      </div>
    </div>
    <div class="yeac_back-top" :style="{ backgroundImage: `url(${resourceBaseUrl}/backTop.png)` }" @click="goTop"></div>
  </div>
</template>
<script>
import { getResourceBaseUrl, getUrlQueryValueByKey } from "@/utils/util";
import { getDetail } from "@/utils/api/yearEndActivityCollectApi";
import { addLog } from "../../utils/commonApi";
import { toGoodsDetail } from "../../utils/InteractionWithJs";

export default {
  data() {
    return {
      resourceBaseUrl: getResourceBaseUrl(),
      brandList: [
        {
          width: 77,
          url: "BSJ",
          area: "BSJZQ",
          activityList: [
            { id: "4db7d488-16b5-4023-bfda-5f8e5cef0e79", type: 1, number: 1 },
            { id: "47a656e7-ded2-41f7-ab0d-9b07526158a6", type: 1, number: 1 }
          ],
        },
        {
          width: 41,
          url: "BC",
          area: "BCZQ",
          activityList: [
            { id: "", type: 2, number: 1, goodsId: 10883062, goodsSn: 'QY20231124134047817', },
            { id: "", type: 2, number: 1, goodsId: 10883063, goodsSn: 'QY20231124134206037' },
            { id: "", type: 2, number: 1, goodsId: 10883064, goodsSn: 'QY20231124134258856' },
            { id: "", type: 2, number: 1, goodsId: 10883065, goodsSn: 'QY20231124134538342' }
          ],
        },
        {
          width: 54,
          url: "LKSS",
          area: "LKSSZQ",
          activityList: [{ id: "ecdc140a-30f0-4772-aad0-60620feb10f7", number: 1, type: 1 }],
        },
        {
          width: 41,
          url: "BM",
          area: "BMZQ",
          activityList: [
            { id: "438d79bf-c55e-40da-88ec-09a311700e61", number: 1, type: 1 },
            { id: "9596d91c-a170-4f6b-b0cf-d052b00c9612", number: 1, type: 1 }
          ],
        },
        {
          width: 49,
          url: "AD",
          area: "ADZQ",
          activityList: [
            { id: "", type: 2, number: 1, goodsId: 10883066, goodsSn: 'QY20231124134632490' },
            { id: "", type: 2, number: 1, goodsId: 10883067, goodsSn: 'QY20231124134724916' },
            { id: "27e27c1b-c750-494d-8a4f-fa2f58cdd7c9", number: 1, type: 1 }
          ],
        },
        {
          width: 66,
          url: "WEW",
          area: "WEWZQ",
          activityList: [
            { id: "", type: 2, number: 1, goodsId: 10883069, goodsSn: 'QY20231124134911050' },
            { id: "", type: 2, number: 1, goodsId: 10883068, goodsSn: 'QY20231124134829617' },
          ],
        },
        {
          width: 72,
          url: "JBLH",
          area: "JBLHZQ",
          activityList: [
            { id: "", type: 2, number: 1, goodsId: 10883070, goodsSn: 'QY20231124134954554' },
            { id: "", type: 2, number: 1, goodsId: 10883071, goodsSn: 'QY20231124135036264' }
          ],
        },
        {
          width: 65,
          url: "YQFT",
          area: "YQFTZQ",
          activityList: [
            { id: "c08eb845-fb29-492f-a581-b21ecf18e500", number: 1, type: 1 },
            { id: "3bd84103-9308-40d5-ab41-49af045bbd3f", number: 1, type: 1 },
            { id: "86639cfb-8775-432a-b761-6861991c70e5", number: 1, type: 1 }
          ],
        },
        {
          width: 68,
          url: "GQFT",
          area: "GQFTZQ",
          activityList: [
            { id: "0b201cfd-07ef-4654-8772-fd041a4411f3", number: 1, type: 1 },
            { id: "", type: 2, number: 1, goodsId: 10883072, goodsSn: 'QY20231124135132546' }
          ],
        },
        {
          width: 39,
          url: "NS",
          area: "NSZQ",
          activityList: [{ id: "", number: 1, type: 2, goodsId: 10883073, goodsSn: 'QY20231124135210459' }],
        },
        {
          width: 64,
          url: "GB",
          area: "GBZQ",
          activityList: [{ id: "", number: 1, type: 2, goodsId: 10883074, goodsSn: 'QY20231124135256340' }],
        },
        {
          width: 67,
          url: "DF",
          activityList: []
        },
      ],
      currentBrandIndex: 0,
      clickStatus: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    document.title = '品牌活动专区'
    this.userId = getUrlQueryValueByKey(location.href, 'userId') || '';
    this.token = getUrlQueryValueByKey(location.href, "token") || '';
    const accessRefer =
      getUrlQueryValueByKey(location.href, "accessRefer") || location.href;
    addLog(accessRefer, 24, '12月品牌活动')
    this.init();

    window.addEventListener('pageshow', () => {
      this.scrollToPrevPosition();
    });
  },
  methods: {
    handleBrandSelect(index) {
      this.currentBrandIndex = index;
      this.clickStatus = true;
      document.querySelector('#' + this.brandList[index].url).scrollIntoView()
    },
    goTop() {
      window.scrollTo(0, 0)
      this.currentBrandIndex = 0;
    },
    toActivityPage(type, id, goodsSn, goodsId) {
      let scrollTop =  document.documentElement.scrollTop || document.body.scrollTop
      localStorage.setItem('scrollTop', scrollTop);

      switch (type) {
        case 1:
          // this.$router.push({path: '/subjectCoupon', query: {subjectId: id, userId: this.userId, token: this.token}})
          location.href = `${location.origin}/h5/#/subjectCoupon?subjectId=${id}&userId=${this.userId}&token=${this.token}`
          break;
        case 2:
          toGoodsDetail(type, goodsId, goodsSn)
          break;

        default:
          break;
      }
    },
    async init() {
      const { errno, data, errmsg } = await getDetail()
      if (!errno) {
        data.forEach((item) => {
          this.brandList.forEach((item1) => {
            item1.activityList.forEach((item2) => {
              if (item2.goodsSn == item.goodsSn) {
                item2.number = item.number
              }
            })
          })
        })
        this.scrollToPrevPosition();
      }
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.brandList.forEach((item, index) => {
        if (scrollTop >= (document.querySelector('#' + item.url).offsetTop - 75) && !this.clickStatus) {
          this.currentBrandIndex = index;
        }
      })
      setTimeout(() => {
        this.clickStatus = false
      }, 1000);
    },
    scrollToPrevPosition () {
      let scrollTop = Number(localStorage.getItem('scrollTop'));
      if(scrollTop > 0){
        window.scrollTo(0, scrollTop)
        this.handleScroll();
        localStorage.setItem('scrollTop', 0);
      };
    }
  },
  filters: {},
};
</script>
<style>
.yeac_container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100vw;
  min-height: 100vh;
  position: relative;
  background-size: 100% auto;
}

.yeac_header {
  display: block;
  width: 100%;
  height: 4.09rem;
  background-size: 100% auto;
}

.yeac_nav {
  position: fixed;
  top: 2.8rem;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.yeac_nav-back {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  /* height: 0.85rem; */
}

.yeac_nav-selected {
  width: 1rem;
  height: 1.15rem;
  border-top-right-radius: 0.1rem;
  border-bottom-right-radius: 0.1rem;
}

.yeac_nav-top {
  width: 0.75rem;
  height: 0.9rem;
  border-top-right-radius: 0.1rem;
}

.yeac_nav-bottom {
  width: 0.75rem;
  height: 0.9rem;
  border-bottom-right-radius: 0.1rem;
}

.yeac_nav-unselected {
  width: 0.75rem;
  height: 0.9rem;
}

.yeac_nav-line {
  position: absolute;
  bottom: 0;
  width: 0.62rem;
  height: 0.03rem;
  background: #dedede;
  left: 0.06rem;
}

.yeac_activity-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -1.29rem;
}

.yeac_brand-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 6.23rem;
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding-top: 0.75rem;
  padding-bottom: 0.15rem;
  margin-bottom: 0.25rem;
}

.yeac_brand-activity {
  width: 5.92rem;
  /* height: 0.9rem; */
  padding: 0.15rem;
}

.yeac_brand-activity-line {
  border-bottom: 1px solid #dedede;
}

.yeac_brand-area:nth-last-child(7) {
  padding-top: .65rem;
  .yeac_brand-activity:nth-child(2) {
    /* height: 1.1rem; */
  }
}

.yeac_brand-area:nth-last-child(3) {
  padding-top: .6rem !important;

  .yeac_brand-activity {
    /* height: 1.1rem; */
  }
}

.yeac_back-top {
  width: 1.72rem;
  height: 1.06rem;
  margin: 0 auto 1.5rem;
  background-size: 100%;
  background-repeat: no-repeat;
}
</style>
